import React from "react";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestSel } from "@/features/backtest";
import Card from "@/components/Card";
import { Col, Row } from "antd";
import RankTable from "@/modules/Backtest/Results/FeatureImportance/RankTable";

export default () => {
  const featureImportance = useRootSelector(BacktestSel.featureImportance);

  return featureImportance.length > 0 ? (
    <Card title={"Indicator Rank"}>
      <Row gutter={[16,16]}>
        {featureImportance.map((e, i) => (
          <Col span={6} key={i}>
            <RankTable rank={e.rank} ticker={e.ticker} />
          </Col>
        ))}
      </Row>
    </Card>
  ) : null;
};
